import { render, staticRenderFns } from "./staIndex.vue?vue&type=template&id=5a71e38b&scoped=true"
import script from "./staIndex.vue?vue&type=script&lang=js"
export * from "./staIndex.vue?vue&type=script&lang=js"
import style0 from "./staIndex.vue?vue&type=style&index=0&id=5a71e38b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a71e38b",
  null
  
)

export default component.exports